/* eslint-disable no-param-reassign */
const sortHelpExtraConfig = (extraConfig) => {
  if (!extraConfig) return [];
  const newConfig = Object.entries(extraConfig).map(([key, value]) => {
    switch (key) {
      case 'introduction_page':
        return { ...value, index: 0, page: key };
      case 'carts_list_page':
        return { ...value, index: 1, page: key };
      case 'is_missing_or_damaged_page':
        return { ...value, index: 2, page: key };
      case 'bin_number_page':
        return { ...value, index: 3, page: key };
      case 'custom_description_placeholder':
        return { ...value, index: 10, data_page: key };
      case 'custom_confirmation_page':
        return { ...value, index: 11, data_page: key };
      default:
        return { ...value, index: 50, page: key };
    }
  });
  const sorted = Object.entries(newConfig)
    .sort(([, a], [, b]) => a?.index - b?.index)
    .map(([, obj]) => obj);
  return sorted;
};

export default sortHelpExtraConfig;
